__turbopack_context__.v({
  "IncardSection": "ActivitySummary-module__ZWopPG__IncardSection",
  "accentBar": "ActivitySummary-module__ZWopPG__accentBar",
  "actionButtons": "ActivitySummary-module__ZWopPG__actionButtons",
  "addCartBtn": "ActivitySummary-module__ZWopPG__addCartBtn",
  "availableToggle": "ActivitySummary-module__ZWopPG__availableToggle",
  "bookNowBtn": "ActivitySummary-module__ZWopPG__bookNowBtn",
  "bookNowDisabled": "ActivitySummary-module__ZWopPG__bookNowDisabled",
  "calendarIcon": "ActivitySummary-module__ZWopPG__calendarIcon",
  "chevronOpen": "ActivitySummary-module__ZWopPG__chevronOpen",
  "confettiOverlay": "ActivitySummary-module__ZWopPG__confettiOverlay",
  "controlsRow": "ActivitySummary-module__ZWopPG__controlsRow",
  "counter": "ActivitySummary-module__ZWopPG__counter",
  "dateHint": "ActivitySummary-module__ZWopPG__dateHint",
  "detailsList": "ActivitySummary-module__ZWopPG__detailsList",
  "detailsTitle": "ActivitySummary-module__ZWopPG__detailsTitle",
  "enquiryModal": "ActivitySummary-module__ZWopPG__enquiryModal",
  "enquiryOverlay": "ActivitySummary-module__ZWopPG__enquiryOverlay",
  "field": "ActivitySummary-module__ZWopPG__field",
  "fieldLabel": "ActivitySummary-module__ZWopPG__fieldLabel",
  "finalPrice": "ActivitySummary-module__ZWopPG__finalPrice",
  "freeBeesMessage": "ActivitySummary-module__ZWopPG__freeBeesMessage",
  "freeBeesSuccess": "ActivitySummary-module__ZWopPG__freeBeesSuccess",
  "highlightText": "ActivitySummary-module__ZWopPG__highlightText",
  "ieCard": "ActivitySummary-module__ZWopPG__ieCard",
  "ieCardDiv": "ActivitySummary-module__ZWopPG__ieCardDiv",
  "ieGrid": "ActivitySummary-module__ZWopPG__ieGrid",
  "ieIcon": "ActivitySummary-module__ZWopPG__ieIcon",
  "ieNo": "ActivitySummary-module__ZWopPG__ieNo",
  "ieYes": "ActivitySummary-module__ZWopPG__ieYes",
  "includeIcon": "ActivitySummary-module__ZWopPG__includeIcon",
  "includeItem": "ActivitySummary-module__ZWopPG__includeItem",
  "includesBox": "ActivitySummary-module__ZWopPG__includesBox",
  "includesBoxHiddenMobile": "ActivitySummary-module__ZWopPG__includesBoxHiddenMobile",
  "includesGrid": "ActivitySummary-module__ZWopPG__includesGrid",
  "includesTitle": "ActivitySummary-module__ZWopPG__includesTitle",
  "inputSvg": "ActivitySummary-module__ZWopPG__inputSvg",
  "mobileContactCards": "ActivitySummary-module__ZWopPG__mobileContactCards",
  "noData": "ActivitySummary-module__ZWopPG__noData",
  "operatingHours": "ActivitySummary-module__ZWopPG__operatingHours",
  "packageCard": "ActivitySummary-module__ZWopPG__packageCard",
  "packageDetailCol": "ActivitySummary-module__ZWopPG__packageDetailCol",
  "packageDetailColInner": "ActivitySummary-module__ZWopPG__packageDetailColInner",
  "packageDetails": "ActivitySummary-module__ZWopPG__packageDetails",
  "packageHeader": "ActivitySummary-module__ZWopPG__packageHeader",
  "packageHeader2": "ActivitySummary-module__ZWopPG__packageHeader2",
  "packageList": "ActivitySummary-module__ZWopPG__packageList",
  "packageName": "ActivitySummary-module__ZWopPG__packageName",
  "packageNameCol": "ActivitySummary-module__ZWopPG__packageNameCol",
  "priceBlock": "ActivitySummary-module__ZWopPG__priceBlock",
  "readMore": "ActivitySummary-module__ZWopPG__readMore",
  "root": "ActivitySummary-module__ZWopPG__root",
  "sectionBody": "ActivitySummary-module__ZWopPG__sectionBody",
  "sectionCard": "ActivitySummary-module__ZWopPG__sectionCard",
  "sectionHeader": "ActivitySummary-module__ZWopPG__sectionHeader",
  "sectionHeaderStatic": "ActivitySummary-module__ZWopPG__sectionHeaderStatic",
  "sectionTitle": "ActivitySummary-module__ZWopPG__sectionTitle",
  "selectInput": "ActivitySummary-module__ZWopPG__selectInput",
  "startsFrom": "ActivitySummary-module__ZWopPG__startsFrom",
  "startsFromRow": "ActivitySummary-module__ZWopPG__startsFromRow",
  "strikePrice": "ActivitySummary-module__ZWopPG__strikePrice",
  "tabButton": "ActivitySummary-module__ZWopPG__tabButton",
  "tabButtonActive": "ActivitySummary-module__ZWopPG__tabButtonActive",
  "tabContainer": "ActivitySummary-module__ZWopPG__tabContainer",
  "tabContainerPinned": "ActivitySummary-module__ZWopPG__tabContainerPinned",
  "tabContainerSticky": "ActivitySummary-module__ZWopPG__tabContainerSticky",
  "tabPlaceholder": "ActivitySummary-module__ZWopPG__tabPlaceholder",
  "tabSentinel": "ActivitySummary-module__ZWopPG__tabSentinel",
  "tabStickyWrap": "ActivitySummary-module__ZWopPG__tabStickyWrap",
  "toggle": "ActivitySummary-module__ZWopPG__toggle",
  "toggleOption": "ActivitySummary-module__ZWopPG__toggleOption",
  "toggleOptionActive": "ActivitySummary-module__ZWopPG__toggleOptionActive",
  "travelerMenu": "ActivitySummary-module__ZWopPG__travelerMenu",
  "travelerRow": "ActivitySummary-module__ZWopPG__travelerRow",
  "warning": "ActivitySummary-module__ZWopPG__warning",
});
